<template>
  <div class="mission">
    <div class="mission-text">
      <span class="mission-label">Regtime</span> assists property owners<br />
      in evaluating site eligibility for the UAP<br />
      zoning incentive and compatibility<br />
      with the 485x tax exemption program
      <div class="mission-hr-line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mission',
}
</script>

<style scoped>
.mission {
  display: flex;
  padding: 120px 60px;
  flex-direction: column;
  align-items: center;
  gap: 80px;
  align-self: stretch;
}

.mission-text {
  position: relative;
  text-align: center;
  color: var(--Font-navy, #0A1250);
  font-family: "Open Sans";
  font-size: 64px;
  font-style: normal;
  font-weight: 300;
  line-height: 84px;
}

.mission-label {
  color: #104AB1;
  font-family: "Open Sans";
  font-size: 64px;
  font-style: normal;
  font-weight: 700;
  line-height: 84px;
}

.mission-hr-line {
  position: absolute;
  top: 72px;
  width: 90%;
  height: 20px;
  background: url("../assets/horizontal-line.png") no-repeat;
  background-size: 100% 100%;
  z-index: -1;
  left: 50%;
  transform: translateX(-50%);
}
</style>
